import { render, staticRenderFns } from "./courier-select-search.vue?vue&type=template&id=5f04c334&"
import script from "./courier-select-search.vue?vue&type=script&lang=js&"
export * from "./courier-select-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports